<template>
    <div class="com-card">
        <div class="com-card-title">{{ payload.name }}<span class="right-txt">¥{{ form.price || '' }}</span></div>
        <div class="com-card-content">
            <div class="text-wrap com-text-justify">
                <div v-html="payload.brief?.replace(/\n/gi, '<br>')" />
            </div>
            <br>
            <div class="van-hairline--bottom" />
            <br>
            <div class="com-form-wrap">
                <van-form class="com-form-vertical" ref="form">
                    <van-field
                        class="suffix-text"
                        v-model="form.price"
                        :border="false"
                        type="number"
                        label="随喜金额："
                        placeholder="请填写护持的金额"
                        :rules="[
                            { required: true, message: '请填写护持的金额' },
                            {
                                validator: v => Number(v) > 0 ? true : '无效金额'
                            }
                        ]"
                    />
                </van-form>
                <div class="com-form-submit">
                    <DefaultBtn @click="unifiedOrder">登记信息</DefaultBtn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            payload: Object,
            default: () => {}
        },
        data () {
            return {
                form: {
                    price: null
                }
            }
        },
        methods: {
            // 跳转登记信息页面
            unifiedOrder () {
                this.$refs.form.validate().then(err => {
                    if (!err) {
                        // 以时间戳为key，存储页面数据
                        const timestamp = Date.now()

                        localStorage.setItem(timestamp, JSON.stringify({
                            // 普通佛事
                            type: 0,
                            price: this.form.price,
                            pId: this.payload.id,
                            pageData: this.payload,
                            quantity: 1
                        }))
                        this.$router.push({
                            path: 'record',
                            query: { timestamp }
                        })
                    }
                })
            }
        },
        components: {
            
        }
    }
</script>

<style scoped>
    
</style>
